import React, { useState } from 'react';

// Round profile picture for the signed-in user, or their initial when there is no photo.
// The photo URL lives in the auth user's metadata, so showing it needs no extra request.
const UserAvatar = ({ user, name, size = 32, className = '' }) => {
  const [failedUrl, setFailedUrl] = useState(null);
  const url = user?.user_metadata?.avatar_url;
  const initial = (name || user?.email || '?').trim().charAt(0).toUpperCase();
  const box = { width: size, height: size };

  if (url && failedUrl !== url) {
    return (
      <img
        src={url}
        alt=""
        width={size}
        height={size}
        decoding="async"
        onError={() => setFailedUrl(url)}
        className={`rounded-full object-cover ${className}`}
        style={box}
      />
    );
  }

  return (
    <div
      className={`rounded-full bg-yellow-900 text-yellow-100 font-semibold flex items-center justify-center select-none ${className}`}
      style={{ ...box, fontSize: Math.round(size * 0.42) }}
      aria-hidden="true"
    >
      {initial}
    </div>
  );
};

export default UserAvatar;
